import axios from 'axios'
import { isEmpty } from "lodash"
import  { checkErrorData } from './authAction'
import  { updateFetchSpending } from './spendingAction'
import  { formatList, orderByDsc } from './format'
import { updateFetchCharge, updateFetchSalary } from './salariesAction';

export function newPayment(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_PAYMENT_START", payload: "" })
            console.log("new Payment START", {data})
            const res = await axios.post('/payments/new',{data})
            console.log({res});

             
            if(checkErrorData(res, "CREATE_PAYMENT_ERROR", dispatch ) ) {
                dispatch({ type: "NEW_PAYMENT", payload: res.data })
				dispatch({ type: "CREATE_PAYMENT_FULFILLED", payload: "" })
                data.payments_spendings.forEach( spending => {
                    { spending.payment_spending_id &&
                        dispatch(updateFetchSpending(spending.payment_spending_id))
                    }
                    { spending.payment_salary_id &&
                        dispatch(updateFetchSalary(spending.payment_salary_id))
                    }
                    { spending.payment_charge_id &&
                        dispatch(updateFetchCharge(spending.payment_charge_id))
                    }
                })
			}
        } catch(err) {
            console.log("[ERROR] new payment ", err);
            dispatch({
                type: "CREATE_PAYMENT_ERROR",
                payload: err
            })
        }
    }
}
export function newPaymentFullSupplier(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_PAYMENT_START", payload: "" })
            console.log("new Payment START", {data})
            const res = await axios.post('/payments/new/supplier',{data})
            console.log({res});

             
            if(checkErrorData(res, "CREATE_PAYMENT_ERROR", dispatch ) ) {
                dispatch({ type: "NEW_PAYMENT_SUPPLIER", payload: res.data })
				dispatch({ type: "CREATE_PAYMENT_FULFILLED", payload: "" })
                data.payments_spendings.forEach( spending => {
                    { spending.payment_spending_id &&
                        dispatch(updateFetchSpending(spending.payment_spending_id))
                    }
                    { spending.payment_salary_id &&
                        dispatch(updateFetchSalary(spending.payment_salary_id))
                    }
                    { spending.payment_charge_id &&
                        dispatch(updateFetchCharge(spending.payment_charge_id))
                    }
                })
			}
        } catch(err) {
            console.log("[ERROR] new payment ", err);
            dispatch({
                type: "CREATE_PAYMENT_ERROR",
                payload: err
            })
        }
    }
}
export function newPaymentCharge(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_PAYMENT_START", payload: "" })
            console.log("new Payment START", {data})
            const res = await axios.post('/payments/new',{data})
            console.log({res});

             
            if(checkErrorData(res, "CREATE_PAYMENT_ERROR", dispatch ) ) {
                dispatch({ type: "NEW_PAYMENT", payload: res.data })
				dispatch({ type: "CREATE_PAYMENT_FULFILLED", payload: "" })
                data.payments_spendings.forEach( spending => {
                    dispatch(updateFetchCharge(spending.payment_charge_id))
                })
			}
        } catch(err) {
            console.log("[ERROR] new payment ", err);
            dispatch({
                type: "CREATE_PAYMENT_ERROR",
                payload: err
            })
        }
    }
}
export function newPaymentSalary(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_PAYMENT_START", payload: "" })
            console.log("new Payment START", {data})
            const res = await axios.post('/payments/new',{data})
            console.log({res});

             
            if(checkErrorData(res, "CREATE_PAYMENT_ERROR", dispatch ) ) {
                dispatch({ type: "NEW_PAYMENT", payload: res.data })
				dispatch({ type: "CREATE_PAYMENT_FULFILLED", payload: "" })
                data.payments_spendings.forEach( spending => {
                    dispatch(updateFetchSalary(spending.payment_salary_id))
                })
			}
        } catch(err) {
            console.log("[ERROR] new payment ", err);
            dispatch({
                type: "CREATE_PAYMENT_ERROR",
                payload: err
            })
        }
    }
}
export function newPaymentCollab(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_PAYMENT_START", payload: "" })
            console.log("new Payment START", {data})
            const res = await axios.post('/payments/new/collab',{data})
            console.log({res});

             
            if(checkErrorData(res, "CREATE_PAYMENT_ERROR", dispatch ) ) {
                dispatch({ type: "NEW_PAYMENT_COLLAB", payload: formatList(res.data, "payment_id") })
				dispatch({ type: "CREATE_PAYMENT_FULFILLED", payload: "" })
                data.payments_spendings.forEach( spending => {
                    dispatch(updateFetchSpending(spending.payment_spending_id))
                })
                // update user account
                dispatch({ 
                    type: "DEBIT_USER_ACCOUNT", 
                    payload: {
                        user_id: data.payment_collaborator, 
                        amount: data.payment_total_amount
                    } 
                })
			}
        } catch(err) {
            console.log("[ERROR] new payment collab ", err);
            dispatch({
                type: "CREATE_PAYMENT_ERROR",
                payload: err
            })
        }
    }
}
export function newPaymentCollabCharge(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_PAYMENT_START", payload: "" })
            console.log("new Payment START", {data})
            const res = await axios.post('/payments/new/collab/charge',{data})
            console.log({res});

             
            if(checkErrorData(res, "CREATE_PAYMENT_ERROR", dispatch ) ) {
                dispatch({ type: "NEW_PAYMENT_COLLAB", payload: formatList(res.data, "payment_id") })
				dispatch({ type: "CREATE_PAYMENT_FULFILLED", payload: "" })
                data.payments_charges.forEach( charge => {
                    dispatch(updateFetchCharge(charge.payment_charge_id))
                })
                // update user account
                dispatch({ 
                    type: "DEBIT_USER_ACCOUNT", 
                    payload: {
                        user_id: data.payment_collaborator, 
                        amount: data.payment_total_amount
                    } 
                })
			}
        } catch(err) {
            console.log("[ERROR] new payment collab ", err);
            dispatch({
                type: "CREATE_PAYMENT_ERROR",
                payload: err
            })
        }
    }
}

export function fetchPayments() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_PAYMENTS_START", payload: "" })
            console.log("fetch Payment START")
            const res = await axios.get('/payments/get/all')
            console.log({res});
            
            if(checkErrorData(res, "FETCH_PAYMENTS_ERROR", dispatch ) ) {
                dispatch({
                    type: "GET_PAYMENTS",
                    payload: formatList(orderByDsc(res.data, "payment_date"), "payment_id")
                })
				dispatch({ type: "FETCH_PAYMENTS_FULFILLED", payload: "" })
                
			}            
        } catch(err) {
            console.log("[ERROR] get payments list ", err);
        }
    }
}
export function fetchPaymentDetails() {
    return async function(dispatch, getState){
        try{
            dispatch({ type: "FETCH_PAYMENT_DETAILS_START", payload: "" })
            console.log("fetch Payment details START")
            const res = await axios.get('/payments/details/get/all')
            
            if(checkErrorData(res, "FETCH_PAYMENT_DETAILS_ERROR", dispatch ) ) {
                dispatch({
                    type: "GET_PAYMENT_DETAILS",
                    payload: formatList(res.data, "payment_details_id")
                })
                dispatch({ type: "FETCH_PAYMENT_DETAILS_FULFILLED", payload: "" })
                
            }            
        } catch(err) {
            console.log("[ERROR] get payment details list ", err);
        }
    }
}
export function updatePayment(data) {
    return async function(dispatch, getState){
        try{
            dispatch({ type: "UPDATE_PAYMENT_START", payload: "" })

            console.log("update Payment START")
            const res = await axios.post("/payments/update", {data})
            console.log({res});
            
            if(checkErrorData(res, "UPDATE_PAYMENT_ERROR", dispatch ) ) {
                let userID = getState().auth.user.id
                dispatch({
                    type: "UPDATE_PAYMENT",
                    payload: {data, userID}
                })
                dispatch({ type: "UPDATE_PAYMENT_FULFILLED", payload: "" })
                
            }
        } catch(err) {
            console.log("[ERROR] update payment ", err);
            dispatch({
                type: "UPDATE_PAYMENT_ERROR",
                payload: err
                
            })
        }
    }
}
export function deletePayment(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "DELETE_PAYMENT_START", payload: "" })

            console.log("delete payment START")
            const res = await axios.post("/payments/delete", {data: data.payment_id})
            console.log({res});

            if(checkErrorData(res, "DELETE_PAYMENT_ERROR", dispatch ) ) {
                dispatch({
                    type: "DELETE_PAYMENT",
                    payload: data,
                })
                dispatch({ type: "DELETE_PAYMENT_FULFILLED", payload: "" })
            }

        } catch(err) {
            console.log("[ERROR] delete payment ", err);
            dispatch({
                type: "DELETE_PAYMENT_ERROR",
                payload: err
            })
        }
    }
}
